import { useAuth0 } from "@auth0/auth0-react";
import React, { useContext, useEffect } from "react";
import CompanyContext from "./CompanyContext";
import CRMContext from "./CRMContext";
import IdTokenContext from "./IdTokenContext";

const LogoutRoute = () => {
    const { logout } = useAuth0();
    const companyCtx = useContext(CompanyContext);
    const crmCtx = useContext(CRMContext);
    const idTokenCtx = useContext(IdTokenContext);

    useEffect(() => {
        idTokenCtx?.clearIdToken?.();
        crmCtx?.clearCRMAvailability?.();
        companyCtx?.setCompany?.(null);
        localStorage.removeItem("selectedCompany");
        logout({ logoutParams: { returnTo: window.location.origin } });
    }, [companyCtx, crmCtx, idTokenCtx, logout]);

    return <h2>Logging out...</h2>;
};

export default LogoutRoute;
